module.exports = __webpack_public_path__ + "static/background_request_quote_new-f171534f31328a4aae30042d3d4c8b05.jpg";